// For operations where ChangeItem entity is created
export const newChangeItemIcon = 'plus'
// For operations where we modify ChangeItem, e.g. dialogs adding/modifing items in collection
export const changeChangeItemIcon = 'plus'



// WEBPACK FOOTER //
// ./src/components/changeRequests/icons.js